// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2022-2024 (original work) Open Assessment Technologies SA
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
// Utils
import { multiGuard } from '@/core/guards/guardComposer';
import { getFeaturesGuard } from '@/core/guards/featureFlagGuard';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';
// Constants
import { FEATURE_GROUPS } from '@/constants/features';
import config from '@/config';

export const routing = [
    {
        path: [config.routes.groups.home],
        guard: multiGuard([
            getPermissionsGuard([{ resource: 'portal.group', scopes: ['view'] }]),
            getFeaturesGuard(FEATURE_GROUPS)
        ]),
        controller: () => import('./controllers/groups')
    },
    {
        path: [config.routes.groups.create],
        guard: multiGuard([
            getPermissionsGuard([{ resource: 'portal.group', scopes: ['create'] }]),
            getFeaturesGuard(FEATURE_GROUPS)
        ]),
        controller: () => import('./controllers/create.edit')
    },
    {
        path: [config.routes.groups.edit],
        guard: multiGuard([
            getPermissionsGuard([{ resource: 'portal.group', scopes: ['edit'] }]),
            getFeaturesGuard(FEATURE_GROUPS)
        ]),
        controller: () => import('./controllers/create.edit')
    },
    {
        path: [config.routes.groups.selectUsers],
        guard: multiGuard([
            getPermissionsGuard([{ resource: 'portal.group', scopes: ['view'] }]),
            getFeaturesGuard(FEATURE_GROUPS)
        ]),
        controller: () => import('./controllers/addUsers')
    },
    {
        path: [config.routes.groups.selectUsersForExisting],
        guard: multiGuard([
            getPermissionsGuard([{ resource: 'portal.group', scopes: ['view'] }]),
            getFeaturesGuard(FEATURE_GROUPS)
        ]),
        controller: () => import('./controllers/addUsers')
    }
];
